import { useEffect, useState } from "react";
import { ImageUpload } from "../ui/forms/files/ImageUpload";
import { createPlayer, updatePlayer } from "../../services/playersAPI";
import { toast } from "react-toastify";
import { Button } from "../ui/btns/Button";

// CREATE PLAYER IS NOW USED FOR UDPATE ALSO
export const CreatePlayer = ({ player, id, handleClose, fetchPlayer }) => {
  const [isPending, setIsPending] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    nickname: "",
    position: "",
    height: "",
    weight: "",
    shoots: "",
  });
  const [imageFile, setImageFile] = useState(null);

  // SET INITIAL DATA (FILL BY DEFAULT DATA FOR UPDATE)
  useEffect(() => {
    if (player) {
      setFormData({
        firstName: player.firstName || "",
        lastName: player.lastName || "",
        nickname: player.nickname || "",
        position: player.position || "",
        height: player.height || "",
        weight: player.weight || "",
        shoots: player.shoots || "",
      });
    }
  }, [player]);

  const handleImageInput = (file) => {
    setImageFile(file);
  };

  const handleChange = (input) => {
    if (input.target) {
      // Standard HTML input handling
      const { name, value } = input.target;
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    } else {
      // react-select input handling, assuming input is { value, label }
      const { name, value } = input;
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Validate
    if (!formData.firstName || !formData.lastName) {
      toast.error("First name and last name are required", { autoClose: 5000 });
      return;
    }

    // Create a new FormData object
    const formDataToSend = new FormData();

    // Append form data fields
    formDataToSend.append("firstName", formData.firstName);
    formDataToSend.append("lastName", formData.lastName);
    formDataToSend.append("nickname", formData.nickname);
    formDataToSend.append("position", formData.position);
    formDataToSend.append("height", formData.height);
    formDataToSend.append("weight", formData.weight);
    formDataToSend.append("shoots", formData.shoots);

    // Append the image file, if selected
    if (imageFile) {
      formDataToSend.append("image", imageFile);
    }

    let response;
    setIsPending(true);
    if (id) {
      response = await updatePlayer(id, formDataToSend);
      if (response?.success) {
        toast.success("Player updated successfully");
        fetchPlayer();
      } else {
        toast.error("Error updating player", { autoClose: 5000 });
      }

      handleClose();
      setIsPending(false);
    } else {
      response = await createPlayer(formDataToSend);
      if (!response?.success) {
        toast.error("Error creating player", { autoClose: 5000 });
        setIsPending(false);
        return;
      }
      toast.success("Player created successfully");
      setFormData({
        firstName: "",
        lastName: "",
        nickname: "",
        position: "",
        height: "",
        weight: "",
        shoots: "",
      });
      setIsPending(false);
    }

    console.log(response);
  };

  return (
    <div className="flex flex-col items-center justify-center p-6">
      <h1 className="font-heading text-xl font-black uppercase tracking-wide text-flyers-orange mb-4">
        {id ? "Update Player" : "Create Player"}
      </h1>
      <form
        onSubmit={handleSubmit}
        className="bg-flyers-charcoal border border-flyers-dark-gray p-6 rounded-lg w-full max-w-md"
      >
        <div className="mb-4">
          <label htmlFor="firstName" className="label">
            First Name
          </label>
          <input
            type="text"
            id="firstName"
            name="firstName"
            value={formData.firstName}
            onChange={handleChange}
            placeholder="Player's First Name"
            className="input-new"
          />
        </div>
        <div className="mb-4">
          <label htmlFor="lastName" className="label">
            Last Name
          </label>
          <input
            type="text"
            id="lastName"
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
            placeholder="Player's Last Name"
            className="input-new"
          />
        </div>
        <div className="mb-4">
          <label htmlFor="nickname" className="label">
            Nickname
          </label>
          <input
            type="text"
            id="nickname"
            name="nickname"
            value={formData.nickname}
            onChange={handleChange}
            placeholder="Player's Nickname"
            className="input-new"
          />
        </div>
        <div className="mb-4">
          <label htmlFor="position" className="label">
            Position
          </label>
          <input
            type="text"
            id="position"
            name="position"
            value={formData.position}
            onChange={handleChange}
            placeholder="Player's Position"
            className="input-new"
          />
        </div>
        <div className="mb-4">
          <label htmlFor="height" className="label">
            Height
          </label>
          <input
            type="text"
            id="height"
            name="height"
            value={formData.height}
            onChange={handleChange}
            placeholder="Player's Height"
            className="input-new"
          />
        </div>
        <div className="mb-4">
          <label htmlFor="weight" className="label">
            Weight
          </label>
          <input
            type="text"
            id="weight"
            name="weight"
            value={formData.weight}
            onChange={handleChange}
            placeholder="Player's Weight"
            className="input-new"
          />
        </div>
        <div className="mb-4">
          <label htmlFor="shoots" className="label">
            Shooting Preference
          </label>
          <input
            type="text"
            id="shoots"
            name="shoots"
            value={formData.shoots}
            onChange={handleChange}
            placeholder="Player Shooting Preference"
            className="input-new"
          />
        </div>
        <div className="mb-4">
          <ImageUpload labelText="Select Player Image" fileChange={handleImageInput} />
        </div>
        <Button variant="primary" type="submit" className="w-full" disabled={isPending}>
          {id ? "Update Player" : "Create Player"} {isPending && "..."}
        </Button>
      </form>
    </div>
  );
};
